import { IGroupedMention } from 'types/dashboard.types';

/**
 * Obtiene el total de menciones agrupadas
 * @param groupedMentions - Array de menciones agrupadas
 * @returns Total de menciones
 */
export const getTotalMentions = (groupedMentions?: IGroupedMention[]): number => {
  return groupedMentions?.reduce((acc, groupedMention) => acc + groupedMention.mentions.length, 0) || 0;
};
